import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Conversation } from '../../types';

interface ConversationsState {
  list: Conversation[];
  selected: Conversation | null;
  loading: boolean;
  error: string | null;
}

const initialState: ConversationsState = {
  list: [],
  selected: null,
  loading: false,
  error: null,
};

const conversationsSlice = createSlice({
  name: 'conversations',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setConversations: (state, action: PayloadAction<Conversation[]>) => {
      state.list = action.payload;
      state.loading = false;
    },
    setSelectedConversation: (state, action: PayloadAction<Conversation | null>) => {
      state.selected = action.payload;
    },
    addConversation: (state, action: PayloadAction<Conversation>) => {
      state.list.unshift(action.payload);
    },
    updateConversation: (state, action: PayloadAction<Conversation>) => {
      const index = state.list.findIndex(c => c.id === action.payload.id);
      if (index !== -1) {
        state.list[index] = action.payload;
      }
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { 
  setLoading, 
  setConversations, 
  setSelectedConversation, 
  addConversation, 
  updateConversation, 
  setError 
} = conversationsSlice.actions;
export default conversationsSlice.reducer; 